const repairIndexDetailPop = () => import('@/pages/repairIndex/repairIndexDetailPop')
const sceneRepairAddkit = () => import('@/pages/repairIndex/sceneRepairAddkit')
const sceneRepairList = () => import('@/pages/repairIndex/sceneRepairList')
const installationKit = () => import('@/pages/installationKit')
const goTelephone = () => import('@/pages/goTelephone')
const dealScene = () => import('@/pages/dealScene')
const detailTable = () => import('@/pages/detailTable')
const workDetail = () => import('@/pages/workDetail')
const pushOrderDetail = () => import('@/pages/pushOrderDetail')
const sendOrder = () => import('@/pages/sendOrder')
const createOrder = () => import('@/pages/createOrder')
const pushOrder = () => import('@/pages/pushOrder')
const createRepairDetail = () => import('@/pages/createRepairDetail')
const maintenanceRegistration = () => import('@/pages/maintenanceRegistration')
const workTime = () => import('@/pages/workTime')
const disposeTimeOut = () => import('@/components/maintainCommon/disposeTimeOut/')
const overtimeHandle = () => import('@/components/maintainCommon/overtimeHandle/')
const accidentIncrement = () => import('@/components/maintainCommon/accidentIncrement/')

const timeoutLog = () => import('@/components/maintainCommon/overtimeHandle/timeoutLog')

export default [
  {
    path: '/goTelephone',
    name: 'goTelephone',
    component: goTelephone,
    meta: {
      noCache: true
    }
  },
  {
    path: '/workTime',
    name: 'workTime',
    component: workTime,
    meta: {}
  },
  {
    path: '/maintenanceRegistration',
    name: 'maintenanceRegistration',
    component: maintenanceRegistration,
    meta: {}
  },
  {
    path: '/dealScene',
    name: 'dealScene',
    component: dealScene,
    meta: {}
  },
  {
    path: '/detailTable',
    name: 'detailTable',
    component: detailTable,
    meta: {}
  },
  {
    path: '/workDetail',
    name: 'workDetail',
    component: workDetail,
    meta: {
      storeKey: 'trs.getting.detail'// 储存的key 等于undefined则不验证
    }
  },
  {
    path: '/sendOrder',
    name: 'sendOrder',
    component: sendOrder,
    meta: {
      storeKey: 'trs.sending.index'// 储存的key 等于undefined则不验证
    }
  },
  {
    path: '/disposeTimeOut',
    name: 'disposeTimeOut',
    component: disposeTimeOut,
    meta: {
      storeKey: 'trs.sending.index'// 储存的key 等于undefined则不验证
    }
  },
  {
    path: '/overtimeHandle',
    name: 'overtimeHandle',
    component: overtimeHandle
  },
  {
    path: '/accidentIncrement',
    name: 'accidentIncrement',
    component: accidentIncrement
  },
  {
    path: '/timeoutLog',
    name: 'timeoutLog',
    component: timeoutLog
  },
  {
    path: '/pushOrderDetail',
    name: 'pushOrderDetail',
    component: pushOrderDetail,
    meta: {
      noCache: true
    }
  },
  {
    path: '/createOrder',
    name: 'createOrder',
    component: createOrder,
    meta: {}
  },

  {
    path: '/createRepairDetail',
    name: 'createRepairDetail',
    component: createRepairDetail,
    meta: {}
  },
  {
    path: '/pushOrder',
    name: 'pushOrder',
    component: pushOrder,
    meta: {}
  },
  {
    path: '/repairIndexDetailPop',
    name: 'repairIndexDetailPop',
    component: repairIndexDetailPop,
    meta: {}
  },
  {
    path: '/sceneRepairAddkit',
    name: 'sceneRepairAddkit',
    component: sceneRepairAddkit,
    meta: {}
  },
  {
    path: '/installationKit',
    name: 'installationKit',
    component: installationKit,
    meta: {}
  },
  {
    path: '/sceneRepairList',
    name: 'sceneRepairList',
    component: sceneRepairList,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/repairIndex/index.js